import { types, actions } from './requests'
export const CREATELOT_TYPES = {
    ...types('CREATELOT'),
}
export const CREATELOT_ACTIONS = {
    ...actions('CREATELOT'),
}